import { RefObject } from 'react'
import { EmbeddedLink } from '@weblite/ts-action/message'
import { Stack } from '@mui/material'
import { Timestamp } from '@weblite/ts-action/types'
import { VideoPreview } from '$comp/modals/video-player/video-preview'
import { ControlBar } from '$comp/modals/video-player/controls-bar'
import { MediaOwnerListItem } from '$common/media-owner-list-item/media-owner-list-item'
import { MediaViewerCaption } from '$common/media-viewer-caption/media-viewer-caption'

interface Props {
  showCaption: boolean
  sliderValue: number
  onSliderValueChange: (value: number) => unknown
  spentDurationText: string
  videoDurationText: string
  src: string
  poster: string
  isPlaying: RefObject<boolean>
  videoRef: RefObject<HTMLVideoElement>
  videoContainerRef: RefObject<HTMLDivElement>
  playButtonRef: RefObject<HTMLButtonElement>
  captionRef: RefObject<HTMLDivElement>
  onPause: () => unknown
  onPlay: () => unknown
  onTimeUpdate: () => unknown
  onLoadedMetadata?: () => unknown
  description?: string
  owner?: {
    id: string
    type: 'USER' | 'WAPP' | 'CHANNEL'
  }
  date?: Timestamp
  onShare?: () => unknown
  onEnded: () => unknown
  onPrev?: () => unknown
  onNext?: () => unknown
  links: EmbeddedLink[]
}

export function VideoPlayer({
  showCaption,
  isPlaying,
  sliderValue,
  onSliderValueChange,
  spentDurationText,
  videoDurationText,
  playButtonRef,
  videoRef,
  videoContainerRef,
  captionRef,
  src,
  poster,
  onShare,
  description = '',
  owner,
  date,
  onPause,
  onPlay,
  onTimeUpdate,
  onEnded,
  onPrev,
  onNext,
  links,
  onLoadedMetadata,
}: Props) {
  return (
    <>
      <div
        style={{
          position: 'absolute',
          height: '100%',
          width: '100%',
        }}
      >
        <VideoPreview
          videoRef={videoRef}
          videoContainerRef={videoContainerRef}
          isPlaying={isPlaying}
          playButtonRef={playButtonRef}
          src={src}
          poster={poster}
          onPlay={onPlay}
          onPause={onPause}
          onTimeUpdate={onTimeUpdate}
          onEnded={onEnded}
          onPrev={onPrev}
          onNext={onNext}
          onLoadedMetadata={onLoadedMetadata}
        />
      </div>

      <Stack
        ref={captionRef}
        sx={{
          position: 'absolute',
          bottom: 0,
          backgroundColor: '#00000080',
          width: '100%',
        }}
      >
        {description && (
          <MediaViewerCaption description={description} links={links} />
        )}
        {!showCaption ? (
          <ControlBar
            sliderValue={sliderValue}
            onSliderValueChange={onSliderValueChange}
            spentDurationText={spentDurationText}
            audioDurationText={videoDurationText}
          />
        ) : (
          owner && (
            <MediaOwnerListItem owner={owner} date={date} onShare={onShare} />
          )
        )}
      </Stack>
    </>
  )
}
